import { useCallback } from 'react';
import { useRegisterResponseAction } from '../../context/useRegisterResponseAction';
import { focusFormFieldByName } from '../../../utils/forms/focusFormFieldByName';

export const useSetFocusAction = (): void => {
  const handler = useCallback((params: unknown) => {
    if (typeof params !== 'string' || !params) {
      return;
    }

    focusFormFieldByName(params);
  }, []);

  useRegisterResponseAction('setFocus', handler);
};
